/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */

import { LoadingOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import DatePicker from "antd/lib/date-picker";
import Form from "antd/lib/form";
import Image from "antd/lib/image";
import Input from "antd/lib/input";
import Select from "antd/lib/select";
import TimePicker from "antd/lib/time-picker";
import Typography from "antd/lib/typography";
import dayjs from "dayjs";
import React, {
  ChangeEvent,
  Fragment,
  useEffect,
  useRef,
  useState
} from "react";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng
} from "use-places-autocomplete";
import { DATE_FORMAT } from "../../../config/constants";
import useOnClickOutside from "../../../utils/hooks/useOutsideClick";
import { sanitizeString } from "../../../utils/sanitizers";
import { WarningMessage } from "../Messages/WarningMessage";
import { G_Text } from "../Text";
import { InputWrapper } from "./InputWrapper";
import { FileUploader } from "./fileUploader";

const { Option } = Select;
const { Text } = Typography;

const Entry = ({
  type,
  name,
  options,
  mode,
  disabled,
  isGroupDropdown,
  suffixIcon,
  prefixIcon,
  isLoading,
  children,
  inputType,
  label,
  rules,
  size,
  placeholder,
  onChange,
  showSearch,
  onDateChange,
  defaultValue,
  initialValue,
  setLocation,
  dateFormat,
  format,
  showTime,
  location,
  fileName,
  picker,
  allowClear,
  onKeyUp,
  onKeyDown,
  list,
  disabledDate,
  disabledTime,
  selfHandleValue,
  notFoundContent,
  onSearch,
  help,
  className,
  autoComplete,
  step,
  height,
  dropdownRender,
  max = 500
}: any) => {
  const [coordinatesLoading, setCoordinatesLoading] = useState<boolean>(false);
  const {
    ready,
    value,
    suggestions: { status, data },
    clearSuggestions,
    setValue
  } = usePlacesAutocomplete({
    requestOptions: {
      componentRestrictions: { country: ["rw"] }
    },
    debounce: 300
  });

  const placeSuggestionsRef = useRef<any>();

  const handleInput = (e: ChangeEvent<HTMLInputElement>): void => {
    setValue(e.target.value);
    setLocation();
  };

  const handleSelect = (val: string): void => {
    setValue(val, false);
    setCoordinatesLoading(true);
    clearSuggestions();

    getGeocode({ address: val })
      .then((results) => getLatLng(results[0]))
      .then((coordinates) => {
        setLocation && setLocation({ name: val, coordinates });
        setCoordinatesLoading(false);
      })
      .catch((error) => {
        setCoordinatesLoading(false);
        WarningMessage(error);
      });
  };

  useEffect(() => {
    if (location) {
      setValue(location.name, false);
    } else {
      setValue("", false);
    }
  }, []);

  useOnClickOutside(placeSuggestionsRef, () => clearSuggestions());

  const renderSuggestions = (): JSX.Element => {
    const suggestions = data.map(({ place_id, description }: any) => (
      <div
        role="button"
        onClick={() => handleSelect(description)}
        key={place_id}
        className="hover:bg-gray-50 cursor-pointer p-2 text-sm transition-all duration-100"
      >
        {description}
      </div>
    ));

    return <>{suggestions}</>;
  };

  const textInput = (
    <Fragment>
      {label && <Text className="heading2 mb-[8px]">{label}</Text>}
      <InputWrapper
        help={help}
        name={name}
        rules={rules}
        height={height}
        prefixIcon={prefixIcon}
        initialValue={initialValue}
        isLoading={isLoading}
      >
        <Input
          maxLength={max}
          list={list}
          disabled={disabled}
          autoComplete={autoComplete}
          defaultValue={defaultValue}
          className={`my_input ${size === "small" && "sm"} ${className}`}
          placeholder={placeholder}
          allowClear={allowClear}
          suffix={suffixIcon}
          step={step || ""}
          type={inputType}
          onChange={
            selfHandleValue
              ? ({ target }) =>
                  onChange({
                    receivedValue: selfHandleValue,
                    value: target.value
                  })
              : ({ target }: ChangeEvent<HTMLInputElement>) =>
                  onChange && onChange(target.value)
          }
        />
      </InputWrapper>
    </Fragment>
  );

  const selectInput = (
    <Fragment>
      {label && <Text className="heading2 mb-[8px]">{label}</Text>}
      <InputWrapper
        prefixIcon={prefixIcon}
        help={help}
        initialValue={initialValue}
        name={name}
        rules={rules}
        height={height}
        isLoading={isLoading}
      >
        <Select
          notFoundContent={notFoundContent}
          showSearch={showSearch || true}
          placeholder={placeholder}
          allowClear={allowClear}
          mode={mode}
          size="large"
          disabled={disabled}
          loading={isLoading}
          defaultValue={defaultValue}
          onChange={(value: string) => onChange && onChange(value)}
          onKeyUp={({ target }: any) => onKeyUp && onKeyUp(target.value)}
          className={`my_input ${size === "small" && "sm"} ${className}`}
          onKeyDown={({ target }: any) => onKeyDown && onKeyDown(target.value)}
          onSearch={onSearch}
          dropdownRender={dropdownRender}
          suffixIcon={
            suffixIcon || (
              <Image
                preview={false}
                src="/icons/expand_more_black_24dp.svg"
                width={8}
                alt=""
              />
            )
          }
          filterOption={(input, option) =>
            sanitizeString(option?.label as string)?.includes(
              sanitizeString(input || "")
            ) ||
            sanitizeString(option?.title || "")?.includes(
              sanitizeString(input || "")
            ) ||
            sanitizeString(option?.key || "")?.includes(
              sanitizeString(input || "")
            )
          }
        >
          {isGroupDropdown
            ? children
            : React.Children.toArray(
                options?.map((opt: any) => {
                  return (
                    <Option value={opt.value} title={opt.title} {...opt}>
                      <Tooltip title={opt.tooltipTitle}>
                        <G_Text
                          className="w-full"
                          color={opt.disabled ? "ox_2_grey" : "ox_2_black"}
                          pointer={!opt.disabled}
                        >
                          {opt.label}
                        </G_Text>
                      </Tooltip>
                    </Option>
                  );
                })
              )}
        </Select>
      </InputWrapper>
    </Fragment>
  );

  const dropdownSelectInput = (
    <Fragment>
      {label && <Text className="heading2 mb-[8px]">{label}</Text>}
      <Form.Item name={name} rules={rules} help={help}>
        <Select
          showSearch={showSearch || true}
          placeholder={placeholder}
          allowClear={allowClear}
          mode={mode}
          size="large"
          className={`dropdownSelectInput ${
            size === "small" && "sm"
          } ${className}`}
          disabled={disabled}
          loading={isLoading}
          defaultValue={defaultValue}
          onChange={(value: string) => onChange && onChange(value)}
          onKeyDown={({ target }: any) => onKeyDown && onKeyDown(target.value)}
          onSearch={onSearch}
          suffixIcon={suffixIcon}
          filterOption={(input, option) =>
            (((option &&
              option?.key?.toLowerCase()?.indexOf(input?.toLowerCase())) ??
              0 >= 0) ||
              option?.title?.toLowerCase()?.indexOf(input?.toLowerCase())) ??
            0 >= 0
          }
        >
          {isGroupDropdown
            ? children
            : options?.map((opt: any, index: number) => {
                return (
                  <Option key={index} value={opt.value} title={opt.label}>
                    {opt.label}
                  </Option>
                );
              })}
        </Select>
      </Form.Item>
    </Fragment>
  );

  const textAreaInput = (
    <Fragment>
      {label && (
        <Text className="heading2 mb-[8px]">{label} (max: 500 characters)</Text>
      )}
      <InputWrapper
        prefixIcon={prefixIcon}
        help={help}
        initialValue={initialValue}
        name={name}
        rules={rules}
        height={height}
        isLoading={isLoading}
      >
        <Input.TextArea
          rows={4}
          className="my_input"
          placeholder={placeholder}
          defaultValue={defaultValue}
          onChange={({ target }: any) => onChange && onChange(target.value)}
          maxLength={max}
        />
      </InputWrapper>
    </Fragment>
  );

  const passwordInput = (
    <Fragment>
      {label && <Text className="heading2 mb-[8px]">{label}</Text>}
      <InputWrapper
        prefixIcon={prefixIcon}
        help={help}
        initialValue={initialValue}
        name={name}
        rules={rules}
        height={height}
        isLoading={isLoading}
      >
        <Input.Password
          className="my_input p-[12px]"
          allowClear={allowClear}
          placeholder={placeholder}
          onChange={({ target }: any) => onChange && onChange(target.value)}
        />
      </InputWrapper>
    </Fragment>
  );

  const TimeInput = (
    <Fragment>
      {label && <Text className="heading2 mb-[8px]">{label}</Text>}
      <InputWrapper
        prefixIcon={prefixIcon}
        help={help}
        initialValue={initialValue}
        name={name}
        rules={rules}
        height={height}
        isLoading={isLoading}
      >
        <TimePicker
          defaultValue={
            defaultValue
              ? dayjs(defaultValue, dateFormat || DATE_FORMAT?.clock)
              : undefined
          }
          onChange={onDateChange}
          className={`my_datepicker ${size === "small" && "sm"} ${className}`}
          name={name}
          suffixIcon={
            suffixIcon === undefined ? (
              <Image
                src="/icons/ic-actions-calendar.svg"
                alt="Calendar icon"
                width={18}
                height={18}
                preview={false}
              />
            ) : null
          }
          format={dateFormat || format || DATE_FORMAT?.yearDateFormat}
          placeholder={placeholder}
          disabledDate={disabledDate}
        />
      </InputWrapper>
    </Fragment>
  );

  const dateInput = (
    <Fragment>
      {label && <Text className="heading2 mb-[8px]">{label}</Text>}
      <InputWrapper
        prefixIcon={prefixIcon}
        help={help}
        initialValue={initialValue}
        name={name}
        rules={rules}
        height={height}
        isLoading={isLoading}
      >
        <DatePicker
          defaultValue={
            defaultValue ? dayjs(defaultValue, dateFormat) : undefined
          }
          onChange={onDateChange}
          className={`my_datepicker ${size === "small" && "sm"} ${className}`}
          name={name}
          picker={picker}
          suffixIcon={
            suffixIcon || (
              <Image
                src="/icons/ic-actions-calendar.svg"
                alt="Calendar icon"
                preview={false}
                height={18}
                width={18}
              />
            )
          }
          format={dateFormat || format || DATE_FORMAT?.yearDateFormat}
          showTime={showTime}
          placeholder={placeholder}
          disabledDate={disabledDate}
          disabledTime={disabledTime}
        />
      </InputWrapper>
    </Fragment>
  );

  const locationInput = (
    <Fragment>
      {label && <Text className="heading2 mb-[8px]">{label}</Text>}
      <div className="w-full relative">
        <Form.Item name={name} rules={rules} help={help}>
          <Input
            className={`my_input ${size === "small" && "sm"} ${className}`}
            placeholder={placeholder}
            type={inputType}
            value={value}
            onChange={handleInput}
            suffix={coordinatesLoading ? <LoadingOutlined /> : false}
            disabled={!ready || coordinatesLoading}
          />
          {status === "OK" && (
            <div
              ref={placeSuggestionsRef}
              className="bg-white absolute top-[50px] z-10 inset-x-0 rounded-lg shadow-md "
            >
              {renderSuggestions()}
            </div>
          )}
        </Form.Item>
      </div>
    </Fragment>
  );

  const fileInput = (
    <Fragment>
      {label && <Text className="heading2 mb-[8px]">{label}</Text>}

      <Form.Item name={name} help={help}>
        <FileUploader fileName={fileName}>
          <Input
            name={name}
            disabled={disabled}
            defaultValue={defaultValue}
            placeholder={placeholder}
            type={inputType}
            onChange={({ target }: ChangeEvent<HTMLInputElement>) =>
              onChange && onChange(target.files)
            }
          />
        </FileUploader>
      </Form.Item>
    </Fragment>
  );

  switch (type) {
    case "text":
      return textInput;

    case "select":
      return selectInput;

    case "text_area":
      return textAreaInput;

    case "password":
      return passwordInput;

    case "date":
      return dateInput;

    case "location":
      return locationInput;

    case "file":
      return fileInput;

    case "dropdownSelect":
      return dropdownSelectInput;

    case "time-picker":
      return TimeInput;

    default:
      return null;
  }
};

export default Entry;
